import { Component } from '@angular/core';
import { AuthService, AppService } from '../shared/services';
import { AuthService as EsAuthService } from '@examsoft/es-login';
import { TranslationService } from '@examsoft/translation';

@Component({
  selector: 'app-root',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent{

  user;
  appNav = [];
  title: string;
  isAdmin;

  get isReady(){
      return this.translationService.isReady$
  }
  constructor(
    private esAuth: EsAuthService,
    private app: AppService,
    private auth: AuthService,
    private translationService: TranslationService,
  ) {
    this.translationService.initialise();
    this.esAuth.init().subscribe( data => {
      this.user = data ? this.esAuth.user : null;
      this.isAdmin =  this.auth.isAdmin(this.user);
    });

    this.app.currentInstitution$.subscribe( school => {
      this.setTitle(school.institutionName);
    });

  }

  public setTitle(name){
    this.title = name || this.translationService.get('Billing and Usage');
  }

  public logout(){
    this.esAuth.logout();
  }

  public switchInstitution(){
    this.esAuth.switchInstitution();
  }


}

